export const certificateHeaderConfig = {
  headerTitle: 'Certificate Details',
  headerDescription: 'Details of Certificate',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
